import { Link } from 'react-router-dom';
import { Button } from '@/components/Button/Button';
import { ProductCard } from '@/components/ProductCard/ProductCard';
import { useCatalog } from '@/context/CatalogContext';
import { paths } from '@/routes/paths';
import styles from './Home.module.css';

export function Home() {
  const { categories, featured } = useCatalog();

  return (
    <div>
      <section className={styles.hero}>
        <div>
          <div className={styles.kicker}>Handpicked · Small-batch · Shipped with care</div>
          <h1 className={styles.heroTitle}>
            Nice stuff for
            <br />
            curious humans.
          </h1>
          <p className={styles.heroCopy}>
            Books that stay with you, tees that start conversations, and figurines your desk
            didn&apos;t know it needed.
          </p>
          <Button size="lg" to={paths.category('all')}>
            Browse everything →
          </Button>
        </div>

        <div className={styles.heroArt} aria-hidden="true">
          <div className={`${styles.card} ${styles.cardB}`}>B</div>
          <div className={`${styles.card} ${styles.cardF}`}>F</div>
          <div className={`${styles.card} ${styles.cardS}`}>S</div>
        </div>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Shop by category</h2>
        <div className={styles.catGrid}>
          {categories.map((c) => (
            <Link
              key={c.id}
              to={paths.category(c.id)}
              className={styles.catTile}
              style={{ background: c.tint }}
            >
              <div className={styles.catGlyph} style={{ color: c.deep }} aria-hidden="true">
                {c.glyph}
              </div>
              <div className={styles.catName}>{c.name}</div>
              <div className={styles.catCount}>{c.count} items</div>
            </Link>
          ))}
        </div>
      </section>

      <section className={styles.sectionLast}>
        <div className={styles.sectionHead}>
          <h2 className={styles.sectionTitle} style={{ marginBottom: 0 }}>
            Fresh picks
          </h2>
          <Link to={paths.category('all')} className={styles.seeAll}>
            See all →
          </Link>
        </div>
        <div className={styles.grid}>
          {featured.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      </section>
    </div>
  );
}
